import { render, staticRenderFns } from "./BOMForm.vue?vue&type=template&id=459b0e71&"
import script from "./BOMForm.vue?vue&type=script&lang=js&"
export * from "./BOMForm.vue?vue&type=script&lang=js&"
import style0 from "./BOMForm.vue?vue&type=style&index=0&id=459b0e71&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports